import React from 'react';
import axios from 'axios';
import './CategoryItem.css'; // Asegúrate de crear este archivo para los estilos

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const CategoryItem = ({ category, fetchCategories, onEdit }) => {
    const handleDelete = async () => {
        // Confirmación antes de eliminar
        const confirmDelete = window.confirm(`¿Estás seguro de que deseas eliminar la categoría "${category.name}"?`);
        if (!confirmDelete) return;

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('No estás autenticado. Por favor, inicia sesión.');
                return;
            }

            await axios.delete(`${apiUrl}/api/categories/${category._id}`, {
                headers: {
                    Authorization: token // Enviar el token sin el prefijo 'Bearer'
                }
            });

            alert('Categoría eliminada con éxito');
            fetchCategories(); // Actualiza la lista de categorías
        } catch (error) {
            console.error('Error al eliminar la categoría:', error);

            // Verificar si el error es debido a productos asociados
            if (error.response && error.response.status === 400) {
                alert('No se puede eliminar la categoría porque tiene productos asociados.');
            } else {
                alert('Error al eliminar la categoría: ' + (error.response?.data?.message || error.message));
            }
        }
    };

    const handleEdit = () => {
        onEdit(category); // Llama a la función de edición pasada desde CreateCategory.js
    };

    return (
        <div className="category-item">
            <div className="category-info">
                <h3>{category.name}</h3>
                <p>{category.description}</p>
            </div>
            <div className="category-actions">
                <button onClick={handleEdit} className="edit-button">Editar</button>
                <button onClick={handleDelete} className="delete-button">Eliminar</button>
            </div>
        </div>
    );
};

export default CategoryItem;
